<template>
    <div class="section-landing-page">
        <carousel :items="1" :dots="true" :autoplayTimeout="6000" :autoplay="true" :nav="false">
             <template slot="prev"><span class="owl-nav-prev"><img class="show-desktop" src="@/assets/images/landing-page/left-arrow-line-symbol.png" alt="" /></span></template>
            <template slot="next"><span class="owl-nav-next"><img class="show-desktop" src="@/assets/images/landing-page/right-arrow-angle.png" alt="" /></span></template>
            <div class="section-landing-page-item certificate">
                <img class="show-desktop" src="@/assets/images/landing-page/certificate-en.jpg" alt="" />
                <img class="show-mobile" src="@/assets/images/landing-page/certificate-en-mobile.jpg" alt="" />
                <div class="section-landing-page-item__content right" :class="{ isDirectionRtl: $store.state.isRtl }">
                    <div class="section-landing-page-item__content-box primary">
                        <h1 class="section-landing-page-item__content-box-title two-lines">{{ getTranslatedText("there’s always a winner") }}</h1>
                        <p class="section-landing-page-item__content-box-currency">{{ getTranslatedText("OMR") }}</p>
                        <p class="section-landing-page-item__content-box-price">{{ fomarNumberPrice("10000") }}</p>
                    </div>
                    <p class="section-landing-page-item__content-description text-align-left m-top text-m-bottom text-small">{{ getTranslatedText("Your Green Certificate guarantees you entry into our") }}</p>
                    <p class="section-landing-page-item__content-description text-align-left m-bottom">{{ getTranslatedText("weekly raffle draw") }}</p>
                    <div class="section-landing-page-item__box-button">
                        <button @click="redirectRouter('/tickets')" class="section-landing-page-item__button primary">{{ getTranslatedText("buy now") }}</button>
                    </div>
                </div>
            </div>
            <div class="section-landing-page-item blue">
                <img class="show-desktop" src="@/assets/images/landing-page/blue-en.jpg" alt="" />
                <img class="show-mobile" src="@/assets/images/landing-page/blue-en-mobile.jpg" alt="" />
                <div class="section-landing-page-item__content right" :class="{ isDirectionRtl: $store.state.isRtl }">
                    <div class="section-landing-page-item__content-box dangerous">
                        <h1 class="section-landing-page-item__content-box-title">{{ getTranslatedText("Win your best life") }}</h1>
                        <p class="section-landing-page-item__content-box-currency">{{ getTranslatedText(currencyCode) }}</p>
                        <p class="section-landing-page-item__content-box-price">{{ fomarNumberPrice($store.state.listGameLoto[0].estimated_jackpot || "0") }}</p>
                    </div>
                    <p class="section-landing-page-item__content-description text-align-left m-top text-m-bottom">{{ getTranslatedText("Grand prize can reach up to") }}</p>
                    <p class="section-landing-page-item__content-description text-align-left m-bottom text-capitalize">{{ getTranslatedText(currencyCode) }} {{ fomarNumberPrice("10000000") }} </p>
                    <div class="section-landing-page-item__box-button">
                        <button  @click="redirectRouter('/tickets')" class="section-landing-page-item__button dangerous sm-blue">{{ getTranslatedText("buy now") }}</button>
                    </div>
                </div>
            </div>
            <div class="section-landing-page-item plant">
                <img class="show-desktop" v-if="!$store.state.isRtl" src="@/assets/images/landing-page/plant-en.jpg" alt="" />
                <img class="show-desktop" v-else src="@/assets/images/landing-page/plant-ar.jpg" alt="" />
                <img class="show-mobile" src="@/assets/images/landing-page/plant-mobile.jpg" alt="" />
                <div class="section-landing-page-item__content md-center" :class="{ isRtl: $store.state.isRtl, isDirectionRtl: $store.state.isRtl }">
                    <div class="section-landing-page-item__content-title m-bottom-plant">
                        <span>{{ getTranslatedText("Buy.") }}</span>
                        <span class="high-light">{{ getTranslatedText("Plant.") }}</span>
                        <span>{{ getTranslatedText("Win.") }}</span>
                    </div>
                    <p class="section-landing-page-item__content-description text-sm-small">{{ getTranslatedText("Participate in the greenest draw on") }}</p>
                    <p class="section-landing-page-item__content-description text-sm-small m-bottom">{{ getTranslatedText("earth and become an O! Millionaire.") }}</p>
                    <div class="section-landing-page-item__box-button">
                        <button  @click="redirectRouter('/tickets')" class="section-landing-page-item__button primary">{{ getTranslatedText("Buy a green certificate") }}</button>
                    </div>
                </div>
            </div>
            <div class="section-landing-page-item park">
                <img class="show-desktop" v-if="!$store.state.isRtl" src="@/assets/images/landing-page/park-en.jpg" alt="" />
                <img class="show-desktop" v-else src="@/assets/images/landing-page/park-ar.jpg" alt="" />
                <img class="show-mobile" src="@/assets/images/landing-page/park-en-mobile.jpg" alt="" />
                <div class="section-landing-page-item__content max-width md-center" :class="{ isRtl: $store.state.isRtl, isDirectionRtl: $store.state.isRtl }">
                    <img class="section-landing-page-item__content-icon" src="@/assets/images/landing-page/icon-oasis-part-en.png" alt="" />
                    <div class="section-landing-page-item__content-title p-top">
                        <p class="text-m-bottom">{{ getTranslatedText("One Life. One Planet.") }}</p>
                        <p class="m-bottom">{{ getTranslatedText("Make a Difference.") }}</p>
                    </div>
                    <p class="section-landing-page-item__content-description m-bottom-10 text-sm-small">{{ getTranslatedText("The Oasis Park is O! Millionaire’s tree-planting initiative. Buy your Green Certificate to win big every week and make Oman greener and more sustainable.") }}</p>
                    <div class="section-landing-page-item__box-button">
                        <button  @click="redirectRouter('/tickets')" class="section-landing-page-item__button primary">{{ getTranslatedText("Buy a green certificate") }}</button>
                    </div>
                </div>
            </div>
            <div class="section-landing-page-item tv">
               <img class="show-desktop" src="@/assets/images/landing-page/TV.jpg" alt="" />
               <img class="show-mobile" src="@/assets/images/landing-page/tv-mobile.jpg" alt="" />
                <div class="section-landing-page-item__content" :class="{ isDirectionRtl: $store.state.isRtl }">
                    <div class="section-landing-page-item__content-title link-youtube">
                        <span>{{ getTranslatedText("Are you a") }}</span>
                        <span class="high-light">{{ getTranslatedText("Winner?") }}</span>
                    </div>
                    <p class="section-landing-page-item__content-description-top">{{ getTranslatedText("Watch our live draw to find out.") }}</p>
                     <div class="section-landing-page-item__content-box green">
                        <p class="section-landing-page-item__content-box-text">{{ getTranslatedText("Every Thursday") }}</p>
                        <p class="section-landing-page-item__content-box-text">{{ getTranslatedText("at 8pm (gst)") }}</p>
                    </div>
                    <div class="section-landing-page-item__box-button">
                        <button @click="redirectRouterYoutube" class="section-landing-page-item__button dangerous m-top-button">
                            <img src="@/assets/images/landing-page/icon-yt.png" alt="" /> {{ getTranslatedText("Tune in") }}
                        </button>
                    </div>
                </div>
            </div>
        </carousel>

        <!-- <b-modal id="iframe-youtube" hide-footer hide-header size="xl">
            <button class="icon-close" @click="onHideIframeYoutube">
                <img  src="@/assets/images/common/close.png" alt="" />
            </button>
            <b-embed
                id="VideoPlayer"
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/channel/UCCZxGo-Fgh-Vd47jxUBjnww"
                allowfullscreen
            ></b-embed>
        </b-modal> -->
    </div>
</template>
<script>
import { redirectPathApp } from '@/components/common/utils';
import LanguageMixin from "@/mixins/language/language-mixin";
import ButtonCustom from "@/components/common/button";

import carousel from 'vue-owl-carousel'

const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

export default {
    mixins: [LanguageMixin],
    components: { ButtonCustom, carousel },
     data() {
        return {
            currencyCode: CURRENCY_CODE,
            scriptEle: ''
        };
    },
    mounted() {
        let snippetScript = document.createElement('meta')
        snippetScript.setAttribute('name', 'google-site-verification')
        snippetScript.setAttribute('content', 'vqq05UNN-fAXtUpR8JUn8TakOQ7JHj6hjlrUsD7GcjQ')
        this.scriptEle = document.head.appendChild(snippetScript)
    },
    beforeDestroy() {
        document.head.removeChild(this.scriptEle);
    },
    created() {
        this.$store.dispatch("getListGame");
    },
    methods: {
        redirectRouter(path) {
            if (this.$store.state.is_app) {
                redirectPathApp(path);
            } else {
                this.$router.push(path);
            }
        },

        fomarNumberPrice(price) {
            price = parseInt(price)
            return price.toLocaleString("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
        },

        redirectRouterYoutube() {
            window.open('https://www.youtube.com/channel/UCCZxGo-Fgh-Vd47jxUBjnww', "_blank")
        }

        // onHideIframeYoutube() {
        //     this.$bvModal.hide('iframe-youtube')
        // },

        // onShowIframeYoutube() {
        //    this.$bvModal.show('iframe-youtube')
        // },

    },
};
</script>
<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/landing-page/_landing-page.scss"
/>
